import React, { useEffect, useRef, useState } from 'react';
import './CardsSection.css';

const CardsSection = ({ title, items, sectionClass = "", cardClass = "" }) => {
  const cardRefs = useRef([]);
  const [visibleCards, setVisibleCards] = useState([]);

  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      const cardIndex = cardRefs.current.indexOf(entry.target);
      if (cardIndex === -1) return;

      if (entry.isIntersecting) {
        setVisibleCards((prev) =>
          prev.includes(cardIndex) ? prev : [...prev, cardIndex]
        );
      } else {
        setVisibleCards((prev) => prev.filter((index) => index !== cardIndex));
      }
    });
  };

  useEffect(() => {
    const cards = cardRefs.current.slice(); // Snapshot der aktuellen Karten

    if (!cards.length) return;

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5,
    });

    cards.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      cards.forEach((card) => {
        if (card) observer.unobserve(card);
      });
      observer.disconnect();
    };
  }, []);

  return (
    <section className={`cards-section ${sectionClass}`}>
      <div className="cards-container">
        {title && <h2 className="cards-title">{title}</h2>}
        <div className="cards-grid">
          {items.map((item, index) => (
            <div
              key={index}
              className={`card ${
                visibleCards.includes(index) ? 'visible' : ''
              } ${cardClass}`}
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ '--index': index }}
            >
              <div className="card-icon">{item.icon}</div>
              <h3 className="card-title">{item.title}</h3>
              <p className="card-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardsSection;
